import React from 'react';
import './ObjectForm.css';
import { useLanguage } from '../../i18n/LanguageContext';

const FACILITY_LABELS = {
  has_elevator: { sv: 'Hiss', no: 'Heis', dk: 'Elevator' },
  has_storage: { sv: 'Förråd', no: 'Bod', dk: 'Depotrum' },
  has_bike_room: { sv: 'Cykelrum', no: 'Sykkelrom', dk: 'Cykelrum' },
  has_laundry_room: { sv: 'Tvättstuga', no: 'Vaskerom', dk: 'Vaskeri' },
  has_broadband: { sv: 'Fiber (indraget)', no: 'Fiber (innlagt)', dk: 'Fiber (indlagt)' },
  has_courtyard: { sv: 'Innergård', no: 'Bakgård', dk: 'Gårdhave' },
  has_garage: { sv: 'Garage', no: 'Garasje', dk: 'Garage' },
  has_carport: { sv: 'Carport', no: 'Carport', dk: 'Carport' },
  has_patio: { sv: 'Altan', no: 'Terrasse', dk: 'Terrasse' },
  has_parking: { sv: 'Parkeringsplats', no: 'Parkeringsplass', dk: 'Parkeringsplads' },
  has_fireplace: { sv: 'Eldstad/kamin', no: 'Peis/vedovn', dk: 'Pejs/brændeovn' },
  has_municipal_water: { sv: 'Kommunalt V/A', no: 'Kommunalt vann/avløp', dk: 'Kommunalt vand/afløb' },
  has_water_proximity: { sv: 'Vattennära', no: 'Nær vannet', dk: 'Tæt på vandet' },
  has_boat_dock: { sv: 'Båtplats', no: 'Båtplass', dk: 'Bådplads' },
  has_winterized: { sv: 'Vinterbonat', no: 'Vinterisolert', dk: 'Vinterisoleret' },
};

const FacilitiesSelector = ({ propertyType, selectedFacilities, onChange }) => {
  const { language, t } = useLanguage();

  const getFacilityLabel = (facilityId) => {
    const label = FACILITY_LABELS[facilityId];
    return label?.[language] || label?.sv || facilityId;
  };

  // Definiera faciliteter baserat på fastighetstyp
  const getFacilities = () => {
    if (propertyType === 'Lägenhet') {
      return [
        { id: 'has_elevator' },
        { id: 'has_storage' },
        { id: 'has_bike_room' },
        { id: 'has_laundry_room' },
        { id: 'has_broadband' },
        { id: 'has_courtyard' },
      ];
    } else if (propertyType === 'Villa' || propertyType === 'Radhus') {
      return [
        { id: 'has_garage' },
        { id: 'has_carport' },
        { id: 'has_patio' },
        { id: 'has_parking' },
        { id: 'has_fireplace' },
        { id: 'has_broadband' },
      ];
    } else if (propertyType === 'Fritidsboende') {
      return [
        { id: 'has_municipal_water' },
        { id: 'has_garage' },
        { id: 'has_patio' },
        { id: 'has_water_proximity' },
        { id: 'has_fireplace' },
        { id: 'has_boat_dock' },
        { id: 'has_winterized' },
      ];
    } else if (propertyType === 'Tomt') {
      return [
        { id: 'has_municipal_water' },
        { id: 'has_broadband' },
        { id: 'has_water_proximity' },
      ];
    } else if (propertyType === 'Gård/skog') {
      return [
        { id: 'has_garage' },
        { id: 'has_municipal_water' },
        { id: 'has_patio' },
        { id: 'has_fireplace' },
        { id: 'has_broadband' },
      ];
    } else if (propertyType === 'Övrigt') {
      return [
        { id: 'has_garage' },
        { id: 'has_municipal_water' },
        { id: 'has_broadband' },
      ];
    }
    return [];
  };

  const facilities = getFacilities();

  const handleFacilityToggle = (facilityId) => {
    onChange({
      ...selectedFacilities,
      [facilityId]: !selectedFacilities[facilityId]
    });
  };

  if (facilities.length === 0) return null;

  return (
    <div className="facilities-section">
      <h3>{t('objectForm.facilities')}</h3>
      <div className="facilities-grid">
        {facilities.map(facility => (
          <div 
            key={facility.id} 
            className={`facility-button ${selectedFacilities[facility.id] ? 'active' : ''}`}
            onClick={() => handleFacilityToggle(facility.id)}
          >
            {getFacilityLabel(facility.id)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FacilitiesSelector; 
